export const init = <T>(array: T[]): T[] => array.slice(0, array.length - 1);
